export const PACKAGE_NAME = 'DeferEditionModal';
export const TEAM_NAME = 'transmuters-growth';

export const DEFER_EDITION_XFLOW_TO_JPD_MSG_ID_STG = 'stg-defer-edition-crossflow-jpd';
export const DEFER_EDITION_XFLOW_TO_JSW_MSG_ID_STG = 'stg-defer-edition-crossflow-jsw';
export const DEFER_EDITION_XFLOW_TO_JWM_MSG_ID_STG = 'stg-defer-edition-crossflow-jwm';
export const DEFER_EDITION_XFLOW_TO_JSM_MSG_ID_STG = 'stg-defer-edition-crossflow-jsm';

export const DEFER_EDITION_XFLOW_TO_JPD_MSG_ID = 'defer-edition-crossflow-jpd';
export const DEFER_EDITION_XFLOW_TO_JSW_MSG_ID = 'defer-edition-crossflow-jsw';
export const DEFER_EDITION_XFLOW_TO_JWM_MSG_ID = 'defer-edition-crossflow-jwm';
export const DEFER_EDITION_XFLOW_TO_JSM_MSG_ID = 'defer-edition-crossflow-jsm';
